module.exports = __webpack_public_path__ + "media/fire-magic.778e9ada.mp3";